import ResverseCid from "pages/LandingPages/Reverse";

export default function ReverseCidPage() {
  return <ResverseCid />;
}
